import { SHIPMENT_SOLUTION_TYPES } from "~/cores/shipment.core";
import { createReturnReasonConfigBottom, createReturnReasonConfigTop } from "../mockCore";

export function getExchange({ productId }) {
    if (productId === "1") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Weekday-long-sleve-off-white.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Off White",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Weekday-long-sleve-off-white.png",
                    originalVariant: true,
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Off White",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Weekday-long-sleve-off-white.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Off White",
                        },
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Weekday-long-sleve-black.png",
                    inventoryMerchant: 2,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Weekday-long-sleve-black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Weekday-long-sleve-black.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Black",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Weekday-long-sleve-red.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "8",
                    imageUrl: "/mocks/Weekday-long-sleve-red.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "S",
                        },
                    ],
                },
                {
                    id: "9",
                    imageUrl: "/mocks/Weekday-long-sleve-red.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Red",
                        },
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "2") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    imageUrl: "/mocks/Weekday-jeans-lula-blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Lula Blue",
                        },
                        {
                            type: "Size",
                            value: "34",
                        },
                    ],
                },
                {
                    id: "2",
                    imageUrl: "/mocks/Weekday-jeans-verona-blue.png",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Verona Blue",
                        },
                        {
                            type: "Size",
                            value: "36",
                        },
                    ],
                },
                {
                    id: "3",
                    imageUrl: "/mocks/Weekday-jeans-lula-blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Color",
                            value: "Lula Blue",
                        },
                        {
                            type: "Size",
                            value: "34",
                        },
                    ],
                },
                {
                    id: "4",
                    imageUrl: "/mocks/Weekday-jeans-lula-blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Lula Blue",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "5",
                    imageUrl: "/mocks/Weekday-jeans-lula-blue.png",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Lula Blue",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
                {
                    id: "6",
                    imageUrl: "/mocks/Weekday-jeans-verona-blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Color",
                            value: "Verona Blue",
                        },
                        {
                            type: "Size",
                            value: "38",
                        },
                    ],
                },
                {
                    id: "7",
                    imageUrl: "/mocks/Weekday-jeans-verona-blue.png",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Color",
                            value: "Verona Blue",
                        },
                        {
                            type: "Size",
                            value: "40",
                        },
                    ],
                },
            ],
        };
    }
    if (productId === "3") {
        return {
            exchangeAlternatives: [
                {
                    id: "1",
                    inventoryMerchant: 1,
                    inventoryTurnr: 0,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "XS",
                        },
                    ],
                },
                {
                    id: "2",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 2,
                    properties: [
                        {
                            type: "Size",
                            value: "M",
                        },
                    ],
                },
                {
                    id: "3",
                    inventoryMerchant: 0,
                    inventoryTurnr: 1,
                    inventoryTotal: 1,
                    properties: [
                        {
                            type: "Size",
                            value: "L",
                        },
                    ],
                },
                {
                    id: "4",
                    inventoryMerchant: 1,
                    inventoryTurnr: 1,
                    inventoryTotal: 0,
                    properties: [
                        {
                            type: "Size",
                            value: "XL",
                        },
                    ],
                },
            ],
        };
    }

    return {
        exchangeAlternatives: [
            {
                id: "1",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "2",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 2,
                properties: [
                    {
                        type: "Color",
                        value: "Red",
                    },
                    {
                        type: "Size",
                        value: "L",
                    },
                ],
            },
            {
                id: "3",
                inventoryMerchant: 0,
                inventoryTurnr: 1,
                inventoryTotal: 1,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "White",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
            {
                id: "4",
                inventoryMerchant: 1,
                inventoryTurnr: 1,
                inventoryTotal: 0,
                properties: [
                    {
                        type: "Color",
                        value: "Green",
                    },
                    {
                        type: "Size",
                        value: "M",
                    },
                ],
            },
        ],
    };
}

export function getProducts() {
    return {
        sessionId: "170bfc7b-8910-43a7-8903-52c9894ed015",
        shipmentSolutions: [
            {
                carrier: "DOORIS",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 0,
            },
            {
                carrier: "BUDBEE",
                type: SHIPMENT_SOLUTION_TYPES.PICKUP.key,
                cost: 39,
            },
            {
                carrier: "POSTNORD",
                type: SHIPMENT_SOLUTION_TYPES.PRINT_LABEL.key,
                cost: 39,
            },
        ],
        pickupDateSelectionAllowed: true,
        paidShipping: 40,
        turnrShippingCost: 59,
        currencyCode: "SEK",
        refundOptions: [
            {
                type: "BASIC",
            },
            {
                type: "GIFT_CARD",
                bonusPercentage: 0.2,
            },
        ],
        products: [
            {
                productVariantId: 10,
                sessionItemId: 1,
                productName: "Malva Cut Out Long Sleeve",
                imageSrc: "/mocks/Weekday-long-sleve-off-white.png",
                imageAlt: "/mocks/Weekday-long-sleve-off-white.png",
                quantity: 1,
                purchasePrice: 300,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Off White",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
            {
                productVariantId: 20,
                sessionItemId: 2,
                productName: "Sway Mid Bootcut Jeans",
                imageSrc: "/mocks/Weekday-jeans-lula-blue.png",
                imageAlt: "/mocks/Weekday-jeans-lula-blue.png",
                quantity: 1,
                purchasePrice: 500,
                properties: [
                    {
                        type: "Size",
                        value: "36",
                    },
                    {
                        type: "Color",
                        value: "Lula Blue",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigBottom(),
            },
            {
                productVariantId: 30,
                sessionItemId: 3,
                productName: "Essence Printed Sweatshirt",
                imageSrc: "/mocks/Weekday-sweatshirt.png",
                imageAlt: "/mocks/Weekday-sweatshirt.png",
                quantity: 1,
                purchasePrice: 350,
                properties: [
                    {
                        type: "Size",
                        value: "S",
                    },
                    {
                        type: "Color",
                        value: "Green",
                    },
                ],
                returnReasonConfig: createReturnReasonConfigTop(),
            },
        ],
    };
}
